
export default {
  // TODO: generate URL for assets/loader.gif
  loading: '',
  consumerLabSeal: 'https://cdn.shopify.com/s/files/1/0270/3546/7828/files/consumerlab-seal.png?v=1580827331',
};